// @flow
let longTasks = [];

export function initLongTaskObserver() {
  if (window.PerformanceObserver) {
    try {
      const observer = new window.PerformanceObserver((entryList) =>
        entryList.getEntries().map((entry) => longTasks.push(entry.duration)),
      );
      observer.observe({ entryTypes: ['longtask'] });

      window.addEventListener('beforeunload', () => {
        observer.disconnect();
      });

      window.addEventListener('popstate', () => {
        longTasks = [];
      });
    } catch (e) {
      // catch errors thrown from Safari
    }
  }
}

export function getLongTaskDurations() {
  const currentLongTasks = longTasks;
  longTasks = [];
  return currentLongTasks;
}
